import React from "react";
import { Link } from "react-router-dom";

const ContactUs = () => {
  return (
    <>
      <div className="container">
        <div id="top1" className="row">
          <div id="top1right" className="col-md-12 col-sm-12 col-xs-12 my-3">
            <h2>Contact Us</h2>
          </div>
        </div>
      </div>
      <div id="block-system-main" className="block block-system">
        <div className="content">
          <div id="node-10016" className="node node-panel clearfix">
            <div className="content">
              <div className="container">
                <div id="top1" className="row">
                  <div id="top1right" className="col-md-12 col-sm-12 col-xs-12">
                    <div className="panel-pane pane-custom pane-1">
                      <div className="pane-content">
                        <p>
                          <strong>
                            If you have any enquiry, please enter your details
                            below.&nbsp;
                          </strong>
                          <strong>
                            We will contact you as soon as possible
                          </strong>
                          <strong>.</strong>
                        </p>
                      </div>
                    </div>
                    <div className="panel-separator"></div>
                    <div className="panel-pane pane-node">
                      <div className="pane-content">
                        <div
                          id="node-29398"
                          className="node node-webform clearfix"
                        >
                       
                          <div className="content">
                            <div className="field field-name-body field-type-text-with-summary field-label-hidden">
                              <div className="field-items">
                                <div className="field-item even">
                                  <p>
                                    If you wish to contact TGT Weddings - the
                                    leading digital wedding planning platform in
                                    the Middle East and North Africa, kindly
                                    fill in this form:
                                  </p>
                                </div>
                              </div>
                            </div>
                            <form
                              className="webform-client-form"
                              encType="multipart/form-data"
                              action="/contact-us"
                              method="post"
                              id="webform-client-form-29398"
                              acceptCharset="UTF-8"
                            >
                              <div>
                                <div
                                  className="col-md-6"
                                  id="webform-component-your-name"
                                >
                                  <label htmlFor="edit-submitted-your-name">
                                    Your Name{" "}
                                    <span
                                      className="form-required"
                                      title="This field is required."
                                    >
                                      *
                                    </span>
                                  </label>
                                  <input
                                    type="text"
                                    id="edit-submitted-your-name"
                                    name="submitted[your_name]"
                                    value=""
                                    size="60"
                                    maxLength="128"
                                    className="form-control required"
                                  />
                                </div>
                                <div
                                  className="col-md-6 my-2"
                                  id="webform-component-your-e-mail"
                                >
                                  <label htmlFor="edit-submitted-your-e-mail">
                                    Your E-mail{" "}
                                    <span
                                      className="form-required"
                                      title="This field is required."
                                    >
                                      *
                                    </span>
                                  </label>
                                  <input
                                    className="form-control form-text form-email required"
                                    type="email"
                                    id="edit-submitted-your-e-mail"
                                    size="60"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label htmlFor="edit-submitted-how-can-we-help-you">
                                    How can we help you{" "}
                                    <span
                                      className="form-required"
                                      title="This field is required."
                                    >
                                      *
                                    </span>
                                  </label>
                                  <div className="">
                                    <textarea
                                      id="edit-submitted-how-can-we-help-you"
                                      name="submitted[how_can_we_help_you]"
                                      cols="60"
                                      rows="5"
                                      className="form-textarea  form-control"
                                    ></textarea>
                                    <div className="grippie"></div>
                                  </div>
                                </div>
                                <div className="col-md-6 my-3">
                                <button
                                  className="btn btn-primary"
                                  id="edit-actions"
                                >
                                  Submit
                                </button>
                              </div>
                              </div>
                             
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
